import { render, staticRenderFns } from "./ChildNodes.vue?vue&type=template&id=4db9352d&scoped=true&lang=pug"
import script from "./ChildNodes.vue?vue&type=script&lang=js"
export * from "./ChildNodes.vue?vue&type=script&lang=js"
import style0 from "./ChildNodes.vue?vue&type=style&index=0&id=4db9352d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9352d",
  null
  
)

export default component.exports